
import { defineComponent } from 'vue';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent } from '@ionic/vue';

export default defineComponent({
  name: 'Welcome',
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage }
});
